module.exports = __webpack_public_path__ + "img/gambeat_logo_square_red_white_text.9b22e3e2.svg";